module.exports = __webpack_public_path__ + "img/5.516058e4.jpg";